let activeCarouselCardFlowId = '';
let pendingCarouselReturnId = '';

export function beginCarouselCardFlow(cardId) {
  activeCarouselCardFlowId = cardId || '';
  pendingCarouselReturnId = '';
}

export function confirmCarouselCardReturn(cardId) {
  pendingCarouselReturnId = cardId && cardId === activeCarouselCardFlowId ? cardId : '';
  activeCarouselCardFlowId = '';
}

export function getPendingCarouselCardReturn() {
  return pendingCarouselReturnId;
}

export function consumeCarouselCardReturn(cardId) {
  const confirmedCardId = cardId && cardId === pendingCarouselReturnId ? cardId : '';

  activeCarouselCardFlowId = '';
  pendingCarouselReturnId = '';

  return confirmedCardId;
}

export function cancelCarouselCardFlow() {
  activeCarouselCardFlowId = '';
  pendingCarouselReturnId = '';
}
